import React, { FC, memo } from 'react'
import { useSelector } from 'react-redux'
import { isDeveloperEmail } from '@feedyou/utils'

import { useUserInfo } from '../../../store/user'
import { areDevToolsOpenSelector } from '../selectors'
import { useWindowParams } from '../hooks/useWindowParams'
import { FeedbotSuspense } from '../../../components/design-system/FeedbotSuspense'

const DevToolsUi = React.lazy(() =>
  import('./DevToolsUi').then(module => ({ default: module.DevToolsUi }))
)

export const DevTools: FC = memo(function DevTools() {
  useWindowParams()

  const { email } = useUserInfo()

  const isOpen = useSelector(areDevToolsOpenSelector)

  if (!isOpen || !isDeveloperEmail(email)) {
    return null
  }

  return (
    <FeedbotSuspense name="DevToolsUi" fallback={<div></div>}>
      <DevToolsUi />
    </FeedbotSuspense>
  )
})
